export enum StoreName{
	Boards= 'boards' ,
	Columns= 'columns',
	Tasks= 'tasks',
	SyncQueue= 'syncQueue',
	Metadata= 'metadata'
}